/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TimelineItem.vue?vue&type=template&id=587a2664&scoped=true&lang=html&"
import script from "./TimelineItem.vue?vue&type=script&lang=js&"
export * from "./TimelineItem.vue?vue&type=script&lang=js&"
import style0 from "./TimelineItem.vue?vue&type=style&index=0&id=587a2664&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587a2664",
  null
  
)

export default component.exports